import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderSl = () => {
    return (
        <HighlightedText
            text="ZAVRTI KOLO IN OSVOJI BREZPLAČNE VRTLJAJE"
            highlights={[{ word: 'BREZPLAČNE' }, { word: 'VRTLJAJE' }]}
            breakAfterWords={['OSVOJI']}
            className={styles.text_header}
        />
    )
}
